import { ACR_RESOURCE_TYPE } from '../../pages/NRSettings/NRUsersAndAccess/rbac.constants';
import { getDataFromTurbinePPComposedAssetId } from '../../utils/utils';

export function resolveEffectiveResourceScope({
  resourceType = ACR_RESOURCE_TYPE.ORGANIZATION,
  resourceId,
  currentOrgId,
  assetId,
  componentId
}) {
  const effectiveResourceType = resourceType ?? ACR_RESOURCE_TYPE.ORGANIZATION;

  const inferredAssetId = getDataFromTurbinePPComposedAssetId(assetId ?? componentId)?.assetId;

  const effectiveResourceId =
    resourceId ??
    (effectiveResourceType === ACR_RESOURCE_TYPE.ASSET ? inferredAssetId : undefined) ??
    (effectiveResourceType === ACR_RESOURCE_TYPE.ORGANIZATION ? currentOrgId : undefined);

  return {
    resourceType: effectiveResourceType,
    resourceId: effectiveResourceId
  };
}
